const locales = (lang, string) => {
  return stringTranslation[string]?.[lang];
}

const stringTranslation = {
  'callCTA': {
    'en-us': 'Call Blue Cross',
    'fr-ca': 'Appeler Croix Bleue'
  },
  'reloadCTA': {
    'en-us': 'Start Over',
    'fr-ca': 'Recommencer'
  },
  'toggleText': {
    'en-us': 'Toggle between Webchat or FAQ',
    'fr-ca': 'Basculer entre le clavardage ou la FAQ'
  },
  'closeChat': {
    'en-us': "Click to close chat window",
    'fr-ca': "Cliquer pour fermer la fenêtre de clavardage."
  },
  'privacy': {
    'en-us': 'Privacy Policy',
    'fr-ca': 'Politique de confidentialité',
  },
  'privacy-url': {
    'en-us': 'https://qc.bluecross.ca/privacy-policy',
    'fr-ca': 'https://qc.croixbleue.ca/politique-de-confidentialite',
  },
  'q&a': {
    'en-us': "Questions and Answers",
    'fr-ca': "Questions et réponses"
  },
  'faq': {
    'en-us': "Frequently Asked Questions",
    'fr-ca': "Foire aux questions",
  },
  'situation': {
    'fr-ca': "Sélectionnez votre situation",
    'en-us': "Select your situation",
  },
  'assurance_voyage': {
    'fr-ca': "Assurance voyage",
    'en-us': "Travel Insurance"
  },
  'askYourQuestion': {
    'fr-ca': "Poser votre question",
    'en-us': "Ask your question"
  },
  'onboardingWelcome': {
    'fr-ca': "Je suis votre assistant virtuel. Vous pouvez me poser une question sur l'assurance voyage en lien avec la Covid-19 ou la reprise des voyages.",
    'en-us': "I'm your virtual assistant. You can ask me a question about travel insurance and Covid-19 or the resumption of travel."
  },
  'startBtn': {
    'fr-ca': "Commencer",
    'en-us': 'Get started'
  },
  'seeFaqBtn': {
    'fr-ca': "Consulter la FAQ Assurance Voyage",
    "en-us": "View Travel Insurance FAQ",
  },
  'hello': {
    'fr-ca': "Bonjour! 👋",
    'en-us': "Hello! 👋",
  }
}

export default locales;